import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURSpinModel from "../models/BURSpinModel";

export class BURHasMysterySymbolsCondition implements ICondition {
    public check(): boolean {
        return BURSpinModel.mystery_positions.length > 0;
    }
}
